export default "__VITE_ASSET__DfhbUrsh__"